import { useEffect, useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import pdf from '../../Assets/Joshua_Raphael_Bautista_Resume.pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(window.innerWidth);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scale = width > 900 ? 1.5 : width > 600 ? 1.0 : 0.55;

  return (
    <div className="resume-page">
      {/* Header */}
      <div className="resume-page-header">
        <div className="resume-page-eyebrow">{"// resume"}</div>
        <h1 className="resume-page-title">
          Joshua <span className="resume-title-grad">Bautista</span>
        </h1>
        <p className="resume-page-sub">Full Stack Engineer · Phoenix, AZ</p>
        <a
          href={pdf}
          target="_blank"
          rel="noreferrer"
          className="resume-download-btn"
        >
          <AiOutlineDownload size={16} />
          Download PDF
        </a>
      </div>

      {/* PDF viewer */}
      <div className="resume-viewer-wrap">
        <div className="resume-viewer-card">
          <Document
            file={pdf}
            className="resume-doc"
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          >
            {Array.from(new Array(numPages || 0), (_, i) => (
              <Page
                key={i + 1}
                pageNumber={i + 1}
                scale={scale}
                className="resume-page-item"
              />
            ))}
          </Document>
        </div>
      </div>

      {/* Footer CTA */}
      <div className="resume-footer-cta">
        <p className="resume-footer-text">Want to work together?</p>
        <a href="mailto:jrbauti19@gmail.com" className="resume-contact-btn">
          Get in touch
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  );
}

export default ResumeNew;
